import React, { useContext, useEffect, useState } from "react";
import BusinessDataValidation from "../helper/BusinessDataValidation";
import { ConfigContext } from "../context/GlobalContext";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { getImage } from "../Utils/image_helper";
import { toast } from "react-toastify";
import { AddBusiness } from "../data";
import GetBusinessDataLocal from "../data/LocalStorage/Business/GetBusinessDataLocal";
import { Languages } from "../Utils/Languages";
import LoaderView from "./LoaderView";
import Country from "../Utils/countries.json";
import Currancy from "../Utils/currency.json";
import * as actionType from "../context/actions";
import CryptoJS from "crypto-js";
import axios from "axios";

const BusinessAddForm = () => {
  const { state, dispatch } = useContext(ConfigContext);
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [isFetchingGst, setIsFetchingGst] = useState(false);
  const [businessData, setBusinessData] = useState({
    companyPhoto: "",
    companyPhotoURL: "",
    companyName: "",
    gstNumber: "",
    address: "",
    terms: "",
    companyId: new Date()?.getTime()?.toString(),
    creationDate: new Date().getTime(),
    isArchive: false,
    updateDate: new Date().getTime(),
    currency: "IND",
    upiId: ""
  });

  const secretKey = process.env.REACT_APP_UPI_SECRET_KEY;

  const [error, setError] = useState({
    companyName: null,
  });

  const fetchGstDetails = async () => {
    if (!businessData.gstNumber || businessData.gstNumber.length < 15) {
      toast.error("Please enter a valid 15-digit GST number.");
      return;
    }

    setIsFetchingGst(true);
    try {
      // User provided API endpoint for clearTax
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}fetch-gst-data/${businessData.gstNumber}`);

      if (response.data && response.data.status && response.data.data?.taxpayerInfo) {
        const info = response.data.data.taxpayerInfo;

        // Construct address from nested fields
        const addr = info.pradr?.addr || {};
        const addressParts = [
          addr.bno,
          addr.bnm,
          addr.st,
          addr.loc,
          addr.dst,
          addr.stcd,
        ].filter(part => part && part.toString().trim() !== "");

        let finalAddress = addressParts.join(", ");
        if (addr.pncd) {
          finalAddress += ` - ${addr.pncd}`;
        }

        setBusinessData(prev => ({
          ...prev,
          companyName: info.tradeNam || info.lgnm || prev.companyName,
          address: finalAddress || prev.address
        }));

        toast.success("Business details fetched successfully!");
      } else {
        toast.error(response.data?.message || "Taxpayer details not found for this GST number.");
      }
    } catch (error) {
      console.error("GST Fetch Error:", error);
      toast.error("Failed to fetch GST details. This GST number might be invalid or the API is unavailable.");
    } finally {
      setIsFetchingGst(false);
    }
  };

  const [filteredCountries, setFilteredCountries] = useState(Currancy.CountryCurrencyResponse);
  const [selectedItem, setSelectedItem] = useState(null);
  const [field, setField] = useState(false);
  const [currencySearch, setCurrencySearch] = useState("");

  const TaxType = () => {
    let taxType = "TAX";
    const VAT_CURRENCIES = ["EUR", "CZK", "DKK", "HUF", "PLN", "RON", "SEK", "GBP"];
    const GST_CURRENCIES = ["INR", "AUD"];
    const ABN_CURRENCIES = [];
    const SST_CURRENCIES = ["MYR"];
    const CAD_CURRENCIES = ["CAD"];
    if (VAT_CURRENCIES.includes(state?.CURRENCYCODE)) taxType = "VAT";
    else if (GST_CURRENCIES.includes(state?.CURRENCYCODE)) taxType = "GST";
    else if (ABN_CURRENCIES.includes(state?.CURRENCYCODE)) taxType = "ABN";
    else if (SST_CURRENCIES.includes(state?.CURRENCYCODE)) taxType = "SST";
    else if (CAD_CURRENCIES.includes(state?.CURRENCYCODE)) taxType = "GST/HST";

    dispatch({ type: 'TAXTYPE', payload: taxType });
  };
  const encryptUPI = (upi) => {
    return CryptoJS.AES.encrypt(upi, secretKey).toString();
  };

  useEffect(() => {
    TaxType();
  }, [state?.CURRENCYCODE]);
  const storedCurrencyCode = businessData?.currency ||
    state?.CURRENCYCODE ||
    state?.SET_USER?.currency;

  useEffect(() => {
    const matchedCurrency = Currancy.CountryCurrencyResponse.find(
      (c) => c.currencyCode === storedCurrencyCode
    );
    if (matchedCurrency) {
      setSelectedItem(matchedCurrency);
    }
    setFilteredCountries(Currancy.CountryCurrencyResponse);

    if (
      (state?.SET_USER?.social_id?.includes('+'))
    ) {
      setField(true);
    } else {
      setField(false)
    }
  }, [state?.SET_USER]);

  const currencyOptions = filteredCountries.map(row => {
    const country = Country.CurrencyResponse.find(c => c.isoAlpha2 === row.countryCode);
    return {
      value: row.currencyCode,
      label: (
        <div className="d-flex align-items-center gap-2">
          <img
            src={
              country?.flag
                ? `data:image/png;base64,${country.flag}`
                : getImage("euro_flag")
            }
            alt="flag"
            width="25"
            height="15"
          />

          <span>{row.name} ({row.currencyCode} - {row.currencytSymbol})</span>
        </div>
      ),
      raw: row,
    };
  });


  const handleItemClick = (result) => {
    setSelectedItem(result);

    // dispatch({ type: 'SYMBOL', payload: result.currencytSymbol });
    // dispatch({ type: 'CURRENCYCODE', payload: result.currencyCode });
    // dispatch({ type: 'CURRENCYNAME', payload: result.name });

    const country = Country.CurrencyResponse.find(c => c.isoAlpha2 === result.countryCode);
    if (country) {
      dispatch({ type: 'FLAG', payload: country.flag });
    }

    // ✅ Set selected currency code in businessData
    setBusinessData((prevData) => ({
      ...prevData,
      currency: result.currencyCode,
    }));
  };


  const HandleChangeInBusinessData = (field, value) => {
    setBusinessData((prevData) => ({
      ...prevData,
      [field]: value,
    }));

    setError((prevData) => ({
      ...prevData,
      [field]: null,
    }));
  };

  const OnCreatePress = async () => {

    const { isValid, errors } = BusinessDataValidation(businessData);

    if (isValid) {
      setIsLoading(true)

      let encryptedBusinessData = { ...businessData };

      // Encrypt sensitive fields
      if (businessData.upiId) {
        encryptedBusinessData.upiId = encryptUPI(businessData.upiId);
      }
      const { success, message } = await AddBusiness(
        state,
        dispatch,
        encryptedBusinessData
      );
      if (success && message == "New company added successfully!") {
        setIsLoading(false)

        dispatch({
          type: actionType?.SELECTEDBUSINESS,
          payload: businessData?.companyId,
        });

        navigate("/invoice-add");
        toast.success(Languages[state?.LANGUAGE]?.business_add_success_message)
      }
      else {
        setIsLoading(false)
        toast.error(Languages[state?.LANGUAGE]?.business_add_failed_message)
      }
    } else {
      console.log(errors);
      setError(errors);
    }
  };

  const selectedCurrencyOption = currencyOptions.find(
    (opt) => opt.raw.name === selectedItem?.name
  );
  const [filteredCurrencyOptions, setFilteredCurrencyOptions] = useState(currencyOptions);

  const handleCurrencySearch = (e) => {
    const value = e.target.value;
    setCurrencySearch(value);

    const trimmed = value.trim().toLowerCase();

    if (trimmed === "") {
      setFilteredCurrencyOptions(currencyOptions);
    } else {
      const filtered = currencyOptions.filter((opt) => {
        const label = String(opt.label || "").toLowerCase();
        const value = String(opt.value || "").toLowerCase();
        const country = String(opt.raw?.name || "").toLowerCase();

        return (
          label.includes(trimmed) ||
          value.includes(trimmed) ||
          country.includes(trimmed)
        );
      });

      setFilteredCurrencyOptions(filtered);
    }
  };



  return (
    <div className="card shadow-lg p-4 w-100">
      <div className="card-header">

        <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
          {/* Left Side - Back/Close Button */}
          <div className="d-flex align-items-center gap-2">
            <button
              onClick={() => { navigate(-1) }}
            >
              <i class="fa fa-arrow-left" style={{ fontSize: 18 }}></i>
            </button>
            <p className='fw-semibold mb-0' style={{ fontSize: 20 }}>{Languages[state?.LANGUAGE]?.add_business}</p>
          </div>

          {/* Right Side - Other Buttons */}
          <div className="d-flex gap-2">
          </div>
        </div>

      </div>
      <div className="card-body">
        <div className="row">
          <form>
            <div className="row">
              <div className="col-12 col-md-3 text-center">
                <label className="form-label">{Languages[state?.LANGUAGE]?.business_logo}</label>
                {/* Image Preview */}
                <div className="mb-3 mt-3">
                  {businessData?.companyPhoto ? (
                    <label htmlFor="file" className="position-relative d-inline-block image-container">
                      <div className="position-relative">
                        <img
                          id="preview"
                          className="img-fluid rounded-circle shadow-sm image-hover"
                          alt="Company Logo"
                          src={URL.createObjectURL(businessData?.companyPhoto)}
                          style={{
                            width: "160px",
                            height: "160px",
                            objectFit: "cover",
                            cursor: "pointer",
                            transition: "opacity 0.3s ease-in-out",
                          }}
                        />
                        <div className="image-overlay position-absolute top-0 start-0 w-100 h-100 rounded-circle"></div>
                        <div className="edit-icon position-absolute top-50 start-50 translate-middle d-flex align-items-center justify-content-center">
                          <Icon icon="lucide:edit" width="30" height="30" color="white" />
                        </div>
                      </div>
                    </label>
                  ) : (
                    <label htmlFor="file">
                      <div className="d-flex align-items-center justify-content-center rounded-circle shadow-mg" style={{ width: "150px", height: "150px" }}>
                        <img src={getImage("businessform")} style={{ width: "80px", height: "80px" }} />
                      </div>
                    </label>
                  )}
                  <input
                    type="file"
                    id="file"
                    name="companyPhoto"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={(e) => HandleChangeInBusinessData("companyPhoto", e.target.files[0])}
                  />
                </div>
              </div>

              <div className="col-12 col-md-9">
                <div className="row">
                  <div className="col-12 col-md-6 mb-3">
                    <label className="form-label">{Languages[state?.LANGUAGE]?.business_name}<span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className={`form-control wizard-required ${error.companyName ? "border-danger" : ""}`}
                      placeholder={Languages[state?.LANGUAGE]?.enter_business_name}
                      value={businessData.companyName}
                      onChange={(e) => HandleChangeInBusinessData("companyName", e.target.value)}
                    />
                    {error.companyName && <div className="text-danger small mt-1">{Languages[state?.LANGUAGE]?.business_name_error}</div>}
                  </div>

                  <div className="col-12 col-md-6 mb-3">
                    <label className="form-label">{(businessData.currency === "AUD" || state?.CURRENCYCODE === "AUD" || state?.TAXTYPE === "ABN") ? "ABN Number" : `${state?.TAXTYPE} Number`}</label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder={`Enter ${(businessData.currency === "AUD" || state?.CURRENCYCODE === "AUD" || state?.TAXTYPE === "ABN") ? "ABN" : (state?.TAXTYPE || 'Tax')} Number`}
                        value={businessData.gstNumber}
                        onChange={(e) => HandleChangeInBusinessData("gstNumber", (state?.TAXTYPE === "GST" && !(businessData.currency === "AUD" || state?.CURRENCYCODE === "AUD")) ? e.target.value.toUpperCase() : e.target.value)}
                      />
                      {state?.TAXTYPE === "GST" && !(businessData.currency === "AUD" || state?.CURRENCYCODE === "AUD") && (
                        <button
                          className="btn btn-primary-600 d-flex align-items-center gap-1"
                          type="button"
                          onClick={fetchGstDetails}
                          disabled={isFetchingGst}
                          style={{ zIndex: 0 }}
                        >
                          {isFetchingGst ? (
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          ) : (
                            <Icon icon="solar:globus-search-bold" width="18" />
                          )}
                          Fetch
                        </button>
                      )}
                    </div>
                  </div>

                  <div className="col-12 col-md-6 mb-3">
                    <label className="form-label">Select Country</label>
                    <div className="dropdown">
                      <button
                        className="btn btn-outline-primary-600 dropdown-toggle w-100 d-flex justify-content-between align-items-center px-16 py-10 rounded"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <span>{selectedCurrencyOption?.label || "Select Currency"}</span>
                        <i className="bi bi-chevron-down"></i> {/* or use your preferred icon */}
                      </button>
                      <ul
                        className="dropdown-menu w-100 mt-1 shadow-sm border-0 rounded-3 text-center hide-scrollbar"
                        style={{ padding: 0 }}
                      >
                        {/* 🔍 Sticky Search */}
                        <li className="py-2 sticky-top z-2">
                          <input
                            type="text"
                            className="form-control countrybackground"
                            placeholder="Search country..."
                            value={currencySearch}
                            onChange={handleCurrencySearch}
                          />
                        </li>

                        {/* ✅ Scrollable container inside a <li> */}
                        <li style={{ maxHeight: "250px", overflowY: "auto" }} className="hide-scrollbar">
                          <ul className="list-unstyled mb-0">
                            {filteredCurrencyOptions.length > 0 ? (
                              filteredCurrencyOptions.map((option) => (
                                <li key={option.id}>
                                  <a
                                    href="#"
                                    className={`dropdown-item d-flex align-items-center gap-2 px-16 py-10 text-secondary-light bg-hover-neutral-200 text-hover-neutral-900 ${selectedCurrencyOption?.value === option.value ? "bg-primary-50 fw-semibold" : ""
                                      }`}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleItemClick(option.raw);
                                      setCurrencySearch("");
                                    }}
                                  >
                                    {option.label}
                                    {selectedCurrencyOption?.value === option.value && (
                                      <i className="bi bi-check2 text-primary-600 ms-auto"></i>
                                    )}
                                  </a>
                                </li>
                              ))
                            ) : (
                              <li className="text-muted text-center small py-2">No Country found</li>
                            )}
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </div>

                  {storedCurrencyCode == "INR" && (
                    <div className="col-12 col-md-6 mb-3">
                      <label className="form-label">Your UPI ID</label>
                      <input
                        type="text"
                        className={`form-control ${error.upiId ? "border-danger" : ""}`}
                        placeholder="Enter UPI ID (e.g., name@upi)"
                        value={businessData.upiId || ""}
                        onChange={(e) => HandleChangeInBusinessData("upiId", e.target.value)}
                      />
                      <small className="text-primary ps-3 mt-1 d-block">Entering a UPI ID will show a QR code on the invoice.</small>
                    </div>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label">{Languages[state?.LANGUAGE]?.address}</label>
                  <textarea
                    className="form-control"
                    rows="3"
                    placeholder={Languages[state?.LANGUAGE]?.enter_address}
                    value={businessData.address}
                    onChange={(e) => HandleChangeInBusinessData("address", e.target.value)}
                  ></textarea>
                </div>
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label">{Languages[state?.LANGUAGE]?.tc_account_details}</label>
              <textarea
                className="form-control"
                rows="3"
                placeholder={Languages[state?.LANGUAGE]?.enter_tc_account_details}
                value={businessData.terms}
                onChange={(e) => HandleChangeInBusinessData("terms", e.target.value)}
              ></textarea>
            </div>

            <div className="d-flex flex-wrap align-items-center justify-content-end gap-2 mt-3">
              <button
                type="reset"
                onClick={() => navigate(-1)}
                className="border btn-sm border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-6 radius-8"
              >
                {Languages[state?.LANGUAGE]?.back}
              </button>
              <button
                type="button"
                className="btn btn-sm btn-primary-600 radius-8 d-inline-flex align-items-center px-40 py-6 radius-8 gap-2"
                onClick={OnCreatePress}
              >
                {Languages[state?.LANGUAGE]?.add}
              </button>
            </div>
          </form>
        </div>
      </div>
      {isLoading && <LoaderView />}
    </div>
  );
};

export default BusinessAddForm;
